import React from 'react';
import './State.scss';

const State = ({value, type = 'default'}) => {
  return <div className={`state state--${type}`}>{value}</div>;
};

export default State;
